// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState } from 'react'
// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import SoftInput from 'components/SoftInput'
import FormField from 'components/FormField'
import { useFieldState } from 'hooks/useFieldState'
import { NumericFormat } from 'react-number-format'

const PercentageField = ({
  value,
  label,
  onChange,
  required,
  placeholder,
  onBlur,
  ...rest
}) => {
  const [rawValue, setRawValue] = useState(value)
  const validateFloat = (value) => {
    return `${value}`.match(/^\d+\.\d{1,2}%$/)
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    validatorFunction: validateFloat,
  })
  const handleOnblurWithValidation = (value) => {
    const isValid = validateFloat(value)
    handleOnblur?.(value)
    if (isValid) {
      onBlur?.(rawValue)
    }
  }
  return (
    <>
      <NumericFormat
        value={value}
        label={label}
        placeholder={placeholder}
        suffix="%"
        fixedDecimalScale
        inputProps={{ inputMode: 'numeric' }}
        decimalScale={2}
        customInput={FormField}
        error={isError}
        success={isSuccess}
        onBlur={handleOnblurWithValidation}
        onValueChange={(values, _sourceInfo) => {
          setRawValue(values.floatValue)
          onChange(values.floatValue)
        }}
        {...rest}
      />
    </>
  )
}

// typechecking props for PercentageField
PercentageField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default PercentageField
